import Link from 'next/link';
import { createContext, PropsWithChildren, useContext } from 'react';

import { WithLinkFactory } from './types';

export type BottomNavigationContextType = WithLinkFactory<{
  content: {
    search: string;
    location: string;
    locations: string;
    dateSelectionTitle: string;
    loadMore: string;
    more: string;
    nights: string;
    guests: string;
    adults: string;
    children: string;
    infants: string;
    adultsDescription: string;
    childrenDescription: string;
    infantsDescription: string;
    confirmCta: string;
  };
  locale: string;
}>;

const BottomNavigationContext = createContext<BottomNavigationContextType>({} as BottomNavigationContextType);

export type BottomNavigationProviderProps = PropsWithChildren<
  Omit<BottomNavigationContextType, 'linkFactory'> & Partial<Pick<BottomNavigationContextType, 'linkFactory'>>
>;

const defaultNextLinkFactory: BottomNavigationContextType['linkFactory'] = (props) => <Link {...props} />;

export const BottomNavigationProvider = ({
  linkFactory = defaultNextLinkFactory,
  children,
  ...context
}: BottomNavigationProviderProps) => (
  <BottomNavigationContext.Provider value={{ ...context, linkFactory }}>{children}</BottomNavigationContext.Provider>
);
export const useBottomNavigation = () => useContext(BottomNavigationContext);
